import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const names = ['María González', 'Carlos López', 'Ana Martínez', 'Roberto Sánchez', 'Laura Fernández', 'Diego Ramírez', 'Valentina Torres', 'Martín Herrera', 'Sofía Díaz', 'Federico Morales', 'Camila Ruiz', 'Nicolás Aguirre', 'Florencia Castro', 'Sebastián Medina', 'Paula Romero'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1; // 1 to 59 minutes
      setData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Auto dismiss after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      triggerPopup();
      // Set interval for subsequent popups (random between 8-12 seconds)
      const interval = setInterval(() => {
        triggerPopup();
      }, Math.floor(Math.random() * 4000) + 8000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-176">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start space-x-4 relative overflow-hidden" data-id="element-177">
        {/* Progress bar animation */}
        <div className="absolute bottom-0 left-0 h-1 bg-[#d4a017] animate-shrink-x w-full" data-id="element-178"></div>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-179">
          <CheckCircle2Icon className="w-6 h-6 text-green-600" data-id="element-180" />
        </div>

        <div className="flex-grow pr-4" data-id="element-181">
          <p className="text-sm text-gray-800 font-medium leading-snug" data-id="element-182">
            <span className="font-bold" data-id="element-183">{data.name}</span> de {data.city} compró
            Sistema PRO
          </p>
        </div>

        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 focus:outline-none" data-id="element-184">
          <XIcon className="w-4 h-4" data-id="element-185" />
        </button>
      </div>
    </div>;
}